import { render, staticRenderFns } from "./merchantStoreAccountActivation.vue?vue&type=template&id=dc70538e"
import script from "./merchantStoreAccountActivation.vue?vue&type=script&lang=js"
export * from "./merchantStoreAccountActivation.vue?vue&type=script&lang=js"
import style0 from "./merchantStoreAccountActivation.vue?vue&type=style&index=0&id=dc70538e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports